import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'OperationLog',
    column_type: 'id',
  },
  created_at: {
    model_name: 'OperationLog',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'OperationLog',
    column_type: 'datetime',
  },
  event: {
    model_name: 'OperationLog',
    column_type: 'string',
  },
  operator_type: {
    model_name: 'OperationLog',
    column_type: 'string',
  },
  target_type: {
    model_name: 'OperationLog',
    column_type: 'string',
  },
  operator: {
    model_name: 'OperationLog',
    column_type: 'belongs_to',
    extra: {
      association_name: 'operator',
      model_name: '',
    },
  },
  operator_id: {
    model_name: 'OperationLog',
    column_type: 'belongs_to',
    extra: {
      association_name: 'operator',
      model_name: '',
    },
  },
  target: {
    model_name: 'OperationLog',
    column_type: 'belongs_to',
    extra: {
      association_name: 'target',
      model_name: '',
    },
  },
  target_id: {
    model_name: 'OperationLog',
    column_type: 'belongs_to',
    extra: {
      association_name: 'target',
      model_name: '',
    },
  },
  data: {
    model_name: 'OperationLog',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
